import React from 'react';
import { SectionHeading } from './SectionHeading';
import { scenes } from '../../data/landing';
export function Scenes() {
  return <section aria-labelledby="scenes-title" className="bg-cream py-16 md:py-24" data-id="element-196" data-mp="1mkigsjeputao">
      <div className="mx-auto max-w-6xl px-5" data-id="element-197" data-mp="1qoqa6tw4cxf8">
        <SectionHeading id="scenes-title" title="¿Te reconocés en estas escenas?" subtitle="Si te pasó alguna, este megapack es para vos." data-id="element-198" data-mp="1qluc95k9u8qs" />
        <ol className="mx-auto mt-12 grid max-w-5xl gap-4 md:grid-cols-2" data-id="element-199" data-mp="yybzf6jek17s">
          {scenes.map((scene, i) => <li key={scene} className={`flex items-center gap-5 rounded-2xl bg-paper px-6 py-6 shadow-[0_1px_2px_rgba(34,48,47,0.06)] ${i === scenes.length - 1 ? 'md:col-span-2 md:mx-auto md:w-1/2' : ''}`} data-id="element-200" data-mp="12vq72trfq0xo" data-mpi={i}>
              <span className="w-6 shrink-0 text-center font-serif text-3xl leading-none text-accent/70" data-id="element-201" data-mp="f88cyrkp6qrj">{i + 1}</span>
              <span className="text-[17px] font-medium leading-snug text-ink" data-id="element-202" data-mp="k58jf3lglvj6">{scene}</span>
            </li>)}
        </ol>
        <p className="mt-12 text-center font-serif text-2xl italic text-primary md:text-3xl" data-id="element-203" data-mp="39eus7bywpyx1">
          Y tu trabajo merece otra organización →
        </p>
      </div>
    </section>;
}